<script setup lang="ts">
import { dismissToast, toasts, type ToastKind } from '../services/notify';

const icons: Record<ToastKind, string> = {
  success: 'bi-check-circle-fill text-success',
  info: 'bi-info-circle-fill text-primary',
  warning: 'bi-exclamation-triangle-fill text-warning',
  danger: 'bi-x-octagon-fill text-danger',
};
</script>

<template>
  <div class="creator-toasts" aria-live="polite" aria-atomic="false">
    <div v-for="t in toasts" :key="t.id" class="toast show" :role="t.kind === 'danger' ? 'alert' : 'status'">
      <div class="d-flex align-items-start gap-2 p-2 ps-3">
        <i class="bi fs-5 mt-1" :class="icons[t.kind]" aria-hidden="true"></i>
        <div class="flex-grow-1 py-1 min-w-0">
          <div v-if="t.title" class="fw-semibold">{{ t.title }}</div>
          <div class="text-break">{{ t.message }}</div>
          <button
            v-if="t.action"
            type="button"
            class="btn btn-sm btn-primary mt-2"
            @click="
              t.action.run();
              dismissToast(t.id);
            "
          >
            {{ t.action.label }}
          </button>
        </div>
        <button type="button" class="btn-close" :aria-label="$t('app.close')" @click="dismissToast(t.id)"></button>
      </div>
    </div>
  </div>
</template>
